import React from "react";

interface IImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {}

const Image: React.FC<IImageProps> = (imageProps) => {
  return <img {...imageProps} />;
};

export default Image;
